export interface Chip {
    key: string;
    value: string;
    displayName: string;
    displayValue?: string;
}

export interface Field {
    formName: string;
    operator: Operator;
    columnName?: string;
    displayName: string;
    type?: FieldType;
    options?: Option[];
    disabled?: boolean;
}

export enum Operator {
    // tslint:disable-next-line:max-line-length
    LESS = 'LESS', EQUAL = 'EQUAL', GREATER = 'GREATER', LIKE = 'LIKE', NOT = 'NOT', LESS_EQUAL = 'LESS_EQUAL', GREATER_EQUAL = 'GREATER_EQUAL'
}

export enum FieldType {
    INPUT = 'INPUT', DATE = 'DATE', SELECT = 'SELECT', RADIO = 'RADIO', CHECKBOX = 'CHECKBOX'
}

export interface Option {
    key: string | null;
    value: string | null;
    selected?: boolean;
    sqlRestriction?: string;
}

export interface Column {
    key: string;
    display: string;
    options?: Option[];
}

export interface MobileDataView {
    title: Partial<Column>;
    description: Partial<Column>;
    columns: Column[];
}
